<template>
  <div v-if="currentMeanNew" id="mean" :class="$mq" :style="{ minHeight: this.$store.getters.fullWindowHeightMinusFooter }">
  <!-- em. minHeight EI TOIMI JOSTAINN SYYSTÄ!!! -->

    <!-- banner -->
    <div id="showcase-banner" :class="$mq" class="relative">
      <div id="showcase-bg" :class="setClass" class="relative">
        <div class="hero-custom-bg absolute tl-0 br-0 h-full"></div> <!-- taustakuva css:ssä -->
      </div> <!-- liitä tähän vielä taustakuva (vakio kaikille) -->
      <div id="showcase-info" class="w-full mx-auto"> <!-- ks. myös css -->
        <div class="relative flex justify-center px-6">
          <div :class="setClass" class="logo rounded-full wh-10 flex flex-center">
            <i class="material-icons" style="cursor: default;">{{ this.currentMeanNew.categoryIcon }}</i>
            <!-- <i class="material-icons">{{ this.setCategoryIcon }}</i> -->
          </div>
          <h1 class="relative pt-3 txt-bold">{{ this.currentMeanNew.title }}</h1>
        </div>
      </div>
      <!-- navigation -->
      <div class="absolute bg-theme flex py-2 px-3 rounded-3 mt-2 opacity-6 hover-opa-10 color-white noselect" style="top: 0; left: 50%; transform: translateX(-50%);">
        <i @click="navigate('prev')" class="material-icons mr-2">keyboard_arrow_left</i>
        <i @click="navigate('')" class="material-icons">undo</i>
        <i @click="navigate('next')" class="material-icons ml-2">keyboard_arrow_right</i>
      </div>
    </div>

    <!-- other -->
    <div class="showcase wrapper mt-8">
      <!-- main card -->
      <div class="item card" style="grid-column: 1/-1;">
        <div class="mean-content-wrapper" style="max-width: 800px; margin: 0 auto;">

          <div class="content grid">
            <p class="font-10 px-1"><span class="color-grey font-8 txt-bold">keinokategoria: </span>{{ this.currentMeanNew.categoryTitle }}</p>
            <p v-html="currentMeanNew.mainInfo" class="mean-card-main-info px-1 mt-8 mb-4"></p>
            <!-- list of links -bar -->
            <div
              @click="showListOfExamples = !showListOfExamples"
              class="relative w-full h-2 flex justify-between align-center px-1 mt-3 pointer hover-bg-grey-l3"
            >
              <span class="txt-bold">käytetty kohteissa:</span>
              <i v-if="!showListOfExamples" class="material-icons">expand_more</i>
              <i v-else class="material-icons">expand_less</i>
            </div>
            <!-- actual links -->
            <div v-if="!showListOfExamples" class="px-1">
              <ul>
                <hr class="border-0 border-b-l3 mb-2">
                <router-link class="lheight-16 color-theme txt-bold hover-color-theme2 pointer"
                  v-for="(example, index) in relatedExamplesNew.examples"
                  :key="index"
                  :to="{ name: 'kohde', params: { example_id: example.slug } }"
                  tag="li"
                >
                  <span>{{ example.title }}</span>
                </router-link>
              </ul>
            </div>
          </div>

        </div>
      </div>

      <!-- galleria -->
      <Gallery>
        <!-- cards -->
        <gitem-mean
          v-for="(attr, index) in currentMeanNew.attrs"
          :key="index"
          :data="attr"
        ></gitem-mean>
      </Gallery>

      <!-- kuvat, joita käytetty kohteissa kyseisen keinon yhteydessä -->
      <div class="mt-8">
        <h4 class="txt-bold">{{ this.currentMeanNew.title }} kohteissa:</h4>
        <div id="images-of-examples" class="py-3">
          <div v-for="(img, index) in relatedExamplesNew.images" :key="index" @click="setPopupContent(img.image, img.imageText)">
            <div v-if="img.thumbM" class="imgPxl" :style="{ backgroundImage: 'url(' + img.thumbM + ')' }"></div>
            <div v-else class="imgSvg" :style="{ backgroundImage: 'url(' + img.image + ')' }"></div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
// import { mapState, mapGetters } from 'vuex'
import Gallery from '@/components/Gallery.vue'
import GitemMean from '@/components/GitemMean.vue'

export default {
  name: 'mean',

  components: {
    Gallery,
    GitemMean
  },

  data () {
    return {
      showListOfExamples: false
    }
  },

  created () {
    this.$store.dispatch('storeMeans')
    this.$store.dispatch('storeExamples')
  },

  computed: {
    /* ...mapState([
      'vuexCategories',
      'theMeans',
      'theExamples',
      'theExamples'
    ]), */

    // ...mapGetters(['slugsOfMeans']),

    currentMeanNew () {
      let means = this.$store.state.means
      // console.log(means);
      let currentMean = means.find(mean => {
        return mean.slug === this.$route.params.mean_id
      })
      // console.log(currentMean);
      return currentMean
    },

    relatedExamplesNew () {
      let usedInExamples = this.$store.state.examples.filter(example => {
        return example.addedMeans.find(addedMean => {
          return addedMean.slug === this.currentMeanNew.slug
        })
      })
      // console.log(usedInExamples);

      let imgsInExamples = []
      usedInExamples.forEach(exa => {
        exa.addedMeans.filter(e => {
          return e.slug === this.$route.params.mean_id
        })[0].imgTextPairs.forEach(the => {
          imgsInExamples.push(the)
        })
      })
      return {
        examples: usedInExamples,
        images: imgsInExamples
      }
    },

    setClass () {
      return ['group-' + this.currentMeanNew.ref]
    }
  },

  methods: {
    navigate (where) {
      let slugs = this.$store.getters.slugsOfMeans
      let thisIndex = slugs.indexOf(this.$route.params.mean_id)

      if (where === 'prev') {
        if (thisIndex === 0) {
          thisIndex = slugs.length
        }
        thisIndex = thisIndex - 1
        this.$router.push({ name: 'keino', params: { mean_id: slugs[thisIndex] } })
      } else if (where === 'next') {
        thisIndex = thisIndex + 1
        thisIndex = thisIndex % slugs.length
        this.$router.push({ name: 'keino', params: { mean_id: slugs[thisIndex] } })
      } else {
        this.$router.go(-1)
      }
    },

    setPopupContent (img, imgText) {
      this.$store.dispatch('setPopupContent', {
        img: img,
        imgText: imgText
      })
    }
  }

  /* created () {
    this.$store.dispatch('getAllMeans')
    this.$store.dispatch('getAllExamples')
  } */
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

#mean #showcase-bg {
  width: 100%;
  height: 30vh;
  //min-height: 450px;
  max-height: 350px;
  min-height: 200px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  opacity: 0.8;
  #showcase-banner.phone & {
    height: 45vh;
  }
  #showcase-banner.tablet & {
    height: 65vh;
  }
}
#showcase-info {
  max-width: 1100px;
  // #mean.others & { max-width: 1250px; }
  h1 {
    font-size: 3rem;
    #mean.phone & { font-size: 2.2rem; }
    #mean.tablet & { font-size: 2.6rem; }
  }
  .logo {
    position: absolute;
    left: 20px;
    top: -5.5rem;
    /* bottom: -35px; */
    border: 6px solid $color-bg;
    i {
      font-size: 6rem;
      color: white;
    }
  }
}
.hero-custom-bg {
  background: url("../assets/means_bg.svg") no-repeat center center;
  background-size: cover;
}

#images-of-examples {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); grid-gap: 10px;
  .phone & { grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); grid-gap: 10px; }
  .tablet & { grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); grid-gap: 10px; }
  & > div {
    position: relative;
    padding-top: 100%;
    border-radius: 2px;
    cursor: pointer;
    box-shadow: 1px 3px 4px rgba(0, 0, 0, 0.3);
    &:hover {
      box-shadow: 1px 3px 4px rgba(0, 0, 0, 0.3), 1px 1px 20px rgba(0, 0, 0, 0.25);
    }
    div {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 2px;
      background-position: center center;
      background-repeat: no-repeat;
      background-color: white;
    }
    .imgPxl { background-size: cover; }
    .imgSvg { background-size: contain; }
  }
}

/* #image-of-example {
  position: relative;
  padding-top: 100%;
  overflow: hidden;
  cursor: pointer;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
  }
} */

</style>
